'use strict';

import {createHtmlElement, rgbaToHexA} from '../../functions';
import axios from 'axios';
import {Snow} from './Snow';
import {PostFX} from '../post-processing/PostFX';
import {Rain} from './Rain';
import { ShaderMaterial } from 'three';
import { threeJsVariables } from '../../settings';
import { Clouds } from './Clouds';
import { Thunderstorm } from './Thunderstorm';
import { Drizzle } from './Drizzle';
import gsap from 'gsap';
import {getCookie, setCookie} from "../cookies/setAndGetCookies";
import {setActiveLordIcon, setLordIcon} from "../../lordicon";
import {changeLangToCurrent} from "../language/langSwitcher";
import {Switch} from "../toggler/Switch";

export class Weather {
    #api = config.features.weather?.api;
    #settings = config.features.weather?.settings;
    #iconUrl = config.features.weather?.api.iconUrl;
    #weatherIconColors = {
        primaryColor: null,
        secondaryColor: null,
        activeColor: null,
    }
    #apiUrl;
    #weatherData = null;
    #time = null;
    #timeElement = null;


    static #active = config.features.weather?.active;
    static #defaultWeather = '';
    static #selectedWeather = null;
    static #container = null;
    static effects = {};
    static #displayOptions = {
        collapsedHeight: null,
        expandedHeight: null,
    }

    constructor(parent) {
        this.parent = parent;

        if (!Weather.#active) return;

        this.#apiUrl = `${this.#api.domain}?lat=${config.localization.latitude}&lon=${config.localization.longitude}&units=${this.#api.units}&appid=${this.#api.id}`;

        this.#create();
    }

    async #create() {

        const response = await axios.get(this.#apiUrl);

        if (response.status != 200) return;

        this.#weatherData = response.data;

        this.#refreshTime();
        setInterval(() => {
            this.#refreshTime();
        }, 1000);

        this.#getIconColors();

        // console.log(weatherData);

        Weather.#defaultWeather = this.#weatherData.weather[0].main.toLowerCase();
        // Weather.#defaultWeather = 'snow';
        //const currentState = 'snow';

        Weather.#container = createHtmlElement(this.parent, '', 'div', ['weather-widget-wrapp']);

        this.#createWeatherWidget(Weather.#container);
        this.#createDisplayOptions(Weather.#container);

        /*

        const snowElement = createHtmlElement(mainContainer,'snow','label',['weather-item', 'snow']);
        const snow = createHtmlElement(snowElement,'','input',[]);
        snow.type = 'checkbox';
        const rainElement = createHtmlElement(mainContainer,'rain','label',['weather-item', 'rain']);
        const rain = createHtmlElement(rainElement,'','input',[]);
        rain.type = 'checkbox';

        rain.addEventListener('change', (e) =>{
            const state = e.srcElement.checked;
            if (state){
                PostFX.enable();
                Weather.effects.rain.enable();
            } else {
                PostFX.disable();
                Weather.effects.rain.disable();
            }

        });

        snow.addEventListener('change', (e)=>{
            const state = e.srcElement.checked;
            if (state){
                PostFX.enable();
                Weather.effects.snow.enable();
            } else {
                PostFX.disable();
                Weather.effects.snow.disable();
            }
        });


        Weather.effects.snow = new Snow();
        Weather.effects.rain = new Rain();

        */

        // PostFX.enable();
        // Weather.effects.snow.enable();
    }

    #createWeatherWidget(parent) {

        //const d = new Date();
        // convert to msec
        // subtract local time zone offset
        // get UTC time in msec
        //const utc = d.getTime() + (d.getTimezoneOffset() * 60000);

        // create new Date object for different city
        // using supplied offset
        //const nd = new Date(utc + (1000*this.#weatherData.timezone));

        const weatherWidget = createHtmlElement(parent, '', 'div', ['weather-widget']);
        const descriptionWrapp = createHtmlElement(weatherWidget, '', 'div', ['weather-description-wrapp']);
        const currentTemp = createHtmlElement(weatherWidget, Math.round(this.#weatherData.main.temp) + '&#176;', 'div', ['weather-temp']);
        const currentIcon = createHtmlElement(currentTemp, '', 'img', ['weather-icon']);

        currentIcon.src = this.#iconUrl + this.#weatherData.weather[0].icon + '.png';

        const description = createHtmlElement(descriptionWrapp, this.#weatherData.weather[0].description, 'div', ['weather-description']);
        const currentDate = new Date();
        const month = currentDate.toLocaleString('default', { month: 'long' }).substr(0, 3);
        const dateWrapp = createHtmlElement(descriptionWrapp, '', 'div', ['weather-date']);
        const date = createHtmlElement(dateWrapp, month + ' ' + currentDate.getDate(), 'div', ['date']);
        this.#timeElement = createHtmlElement(dateWrapp, `${this.#time.getHours()} : ${this.#time.getMinutes()}`, 'div', ['time']);
    }

    #refreshTime() {
        const d = new Date();
        // convert to msec
        // subtract local time zone offset
        // get UTC time in msec
        const utc = d.getTime() + (d.getTimezoneOffset() * 60000);

        // create new Date object for different city
        // using supplied offset
        this.#time = new Date(utc + (1000*this.#weatherData.timezone));

        if (this.#timeElement) {
            let minutes = this.#time.getMinutes();
            if (minutes < 10) minutes = `0${this.#time.getMinutes()}`;
            this.#timeElement.innerHTML = `${this.#time.getHours()} : ${minutes}`;
        }
    }

    #createDisplayOptions(parent) {
        const displayOptionsWrapper = createHtmlElement(parent, '', 'div', ['display-options']);
        //displayOptionsWrapper.addEventListener('click', this.weatherHandler.bind(this));

        this.#createDisplayOptionsHeader(displayOptionsWrapper);
        this.#createWeatherWidgetToggler(displayOptionsWrapper);
        createHtmlElement(displayOptionsWrapper, '', 'div', ['display-options__separator']);
        this.#createWeatherStates(displayOptionsWrapper);
        this.#applyInitVisibility({displayOptionsWrapper});
        this.#getDisplayOptionsHeights(displayOptionsWrapper);
    }

    #getDisplayOptionsHeights(displayOptionsElement) {
        Weather.#displayOptions.collapsedHeight = displayOptionsElement.offsetHeight;
        displayOptionsElement.style.opacity = 0;
        for (let i = 1; i < displayOptionsElement.children.length; i++) {
            displayOptionsElement.children[i].classList.remove('hidden');
        }
        Weather.#displayOptions.expandedHeight = displayOptionsElement.offsetHeight;
        for (let i = 1; i < displayOptionsElement.children.length; i++) {
            displayOptionsElement.children[i].classList.add('hidden');
        }
        displayOptionsElement.style.opacity = 1;
    }

    #createDisplayOptionsHeader(parent) {
        const weatherItemsHeader = createHtmlElement(parent, '', 'span', ['display-options__header']);
        weatherItemsHeader.addEventListener('click', this.#displayOptionsHeaderHandler);
        const icon = createHtmlElement(weatherItemsHeader, ``, 'span', ['header__icon', 'icon-district']);
        const text = createHtmlElement(weatherItemsHeader, changeLangToCurrent('Display options'), 'span', ['header__text', 'language-string']);
        text.setAttribute('data-dictionary', 'Display options');
        const checker = createHtmlElement(weatherItemsHeader, '', 'span', ['header__checker', 'icon-down2']);
    }

    #createWeatherWidgetToggler(parent) {
        const weatherWidgetToggler = createHtmlElement(parent, '', 'div', ['display-options__weather-widget-toggler', 'display-option']);
        const weatherWidgetText = createHtmlElement(weatherWidgetToggler, changeLangToCurrent('Display weather widget'), 'span', ['weather-widget-toggler__text', 'language-string']);
        weatherWidgetText.setAttribute('data-dictionary', 'Display weather widget');
        const switcher = new Switch(weatherWidgetToggler);
        switcher.checked = true;
        switcher.listener = this.#weatherWidgetSwitcherHandler;
    }

    #createWeatherStates(parent) {

        const weatherStatesWrapper = createHtmlElement(parent, '', 'div', ['display-options__weather-states', 'display-option'])
        const headerText = createHtmlElement(weatherStatesWrapper, changeLangToCurrent('Viewing weather options'), 'span', ['weather-states__header', 'language-string']);
        headerText.setAttribute('data-dictionary', 'Viewing weather options');
        const weatherStatesButtons = createHtmlElement(weatherStatesWrapper, '', 'div', ['weather-states__buttons']);
        weatherStatesButtons.addEventListener('click', this.weatherHandler.bind(this));

        this.#settings.items.forEach(item => {
            const snowElement = createHtmlElement(weatherStatesButtons, '', 'label', ['weather-state', item]);
            snowElement.addEventListener('mouseover', (event) => {
                event.target.setAttribute('colors',`primary:${this.#weatherIconColors.activeColor},secondary:${this.#weatherIconColors.activeColor}`);
            });
            snowElement.addEventListener('mouseout', (event) => {
                if (event.target.getAttribute('isActiveWeather') === 'true') return;
                event.target.setAttribute('colors',`primary:${this.#weatherIconColors.primaryColor},secondary:${this.#weatherIconColors.secondaryColor}`);
            });

            setLordIcon(item, snowElement);
            this.item = createHtmlElement(snowElement, '', 'input', []);
            this.item.type = 'checkbox';
            this.item.id = item;

            switch (item) {
                case 'rain':
                    Weather.effects.rain = new Rain();
                    break;
                case 'snow':
                    Weather.effects.snow = new Snow();
                    break;
                case 'drizzle':
                    Weather.effects.drizzle = new Drizzle();
                    break;
                case 'clouds':
                    Weather.effects.clouds = new Clouds();
                    break;
                case 'thunderstorm':
                    // Weather.effects.thunderstorm = new Thunderstorm();
                    Weather.effects.thunderstorm = Weather.effects.rain;
                    break;
            }

            if(config.features.weather.currentWeather && item === Weather.#defaultWeather){
                this.item.checked = true;
                this.weatherHandler({ target: this.item });
            }
        });
    }

    #applyInitVisibility(elements) {
        const visibility = {
            displayOptions: 'hidden',
            weatherWidget: 'expanded'
        }
        const weatherWidgetCookie = getCookie('weatherWidget');

        if (weatherWidgetCookie) {
            //visibility.displayOptions = JSON.parse(weatherWidgetCookie)?.displayOptions || 'hidden';
            visibility.weatherWidget = JSON.parse(weatherWidgetCookie)?.weatherWidget || 'expanded';
        }

        if (visibility.displayOptions === 'hidden') {
            for (let i = 1; i < elements.displayOptionsWrapper.children.length; i++) {
                elements.displayOptionsWrapper.children[i].classList.add('hidden');
            }
        }

        if (visibility.weatherWidget === 'hidden') {
            const weatherWidgetElement = document.querySelector('.weather-widget');
            const switcherCheckbox =  weatherWidgetElement.parentElement.querySelector('.switch__checkbox');

            weatherWidgetElement.classList.add('hidden');
            switcherCheckbox.checked = false;
        }
    }

    #weatherWidgetSwitcherHandler(event) {
        let glogalWeatherWidgetCookie = getCookie('weatherWidget');
        if (!glogalWeatherWidgetCookie) {
            glogalWeatherWidgetCookie = {
                weatherWidget: 'hidden'
            };
        } else {
            glogalWeatherWidgetCookie = JSON.parse(glogalWeatherWidgetCookie);
        }

        const ANIMATION_DURATION = 0.6;
        const weatherWidgetElement = document.querySelector('.weather-widget');
        if (event.target.checked) {
            weatherWidgetElement.classList.remove('hidden');
            gsap.fromTo(
              weatherWidgetElement,
              {opacity: 0},
              {opacity: 1, duration: ANIMATION_DURATION});
            glogalWeatherWidgetCookie.weatherWidget = 'expanded';
        } else {
            gsap.fromTo(
              weatherWidgetElement,
              {opacity: 1},
              {opacity: 0, duration: ANIMATION_DURATION,
                  onComplete: () => {
                  weatherWidgetElement.classList.add('hidden');
              }},
            );
            //weatherWidgetElement.classList.add('hidden')
            glogalWeatherWidgetCookie.weatherWidget = 'hidden';
        }

        setCookie('weatherWidget', JSON.stringify(glogalWeatherWidgetCookie));
    }

    #displayOptionsHeaderHandler(event) {
        const displayOptionsElement = event.target.closest('.display-options');
        const checkerElement = displayOptionsElement.querySelector('.header__checker');
        const ANIMATION_DURATION = 0.3;
        const ANIMATION_DURATION2 = 0.1;

        if (displayOptionsElement.children[1].classList.contains('hidden')) {
            gsap.to(checkerElement, {rotate: 180, duration: ANIMATION_DURATION});
            gsap.fromTo(
              displayOptionsElement,
              {height: Weather.#displayOptions.collapsedHeight},
              {height: Weather.#displayOptions.expandedHeight, duration: ANIMATION_DURATION}
            );
            for (let i = 1; i < displayOptionsElement.children.length; i++) {
                displayOptionsElement.children[i].classList.remove('hidden');
                gsap.fromTo(
                  displayOptionsElement.children[i],
                  {opacity: 0},
                  {opacity: 1, duration: ANIMATION_DURATION, delay: .2}
                );
            }
        } else {
            gsap.to(checkerElement, {rotate: 0, duration: ANIMATION_DURATION});
            for (let i = 1; i < displayOptionsElement.children.length; i++) {
                gsap.fromTo(
                  displayOptionsElement.children[i],
                  {opacity: 1},
                  {opacity: 0, duration: 0,
                      onComplete: () => {
                          displayOptionsElement.children[i].classList.add('hidden');
                      }
                  }
                );
            }
            gsap.fromTo(
              displayOptionsElement,
              {height: Weather.#displayOptions.expandedHeight},
              {height: Weather.#displayOptions.collapsedHeight, duration: ANIMATION_DURATION}
            );
        }
    }

    #getIconColors() {
        const {primary,secondary} = config.features.icons.color;

        const primaryRgba = config.style.colors.find(color => color.key === primary) || { value: '255,255,255,1' };
        const secondaryRgba = config.style.colors.find(color => color.key === secondary) || { value: '255,255,255,1' };
        const activeRgba = config.style.colors.find(color => color.key === 'brand2');

        this.#weatherIconColors.primaryColor = rgbaToHexA(primaryRgba.value.split(','),false);
        this.#weatherIconColors.secondaryColor = rgbaToHexA(secondaryRgba.value.split(','),false);
        this.#weatherIconColors.activeColor = rgbaToHexA(activeRgba.value.split(','), false);
    }

    #timeHandler() {

    }

    weatherHandler(e) {
        const icon = e.target.parentElement.querySelector('.lord__icon');

        if (e.target.id){
           const currentId = e.target.id;
           if (Weather.#selectedWeather) {
               PostFX.disable();
               Weather.effects[Weather.#selectedWeather.id].disable();
               Weather.#selectedWeather.checked = false;
               Weather.#selectedWeather = null;
           }

           if (e.target.checked) {
               const weatherStatesWrapper = e.target.closest('.weather-states__buttons');
               const weatherIcons = weatherStatesWrapper.getElementsByClassName('lord__icon');
               for (let i = 0; i < weatherIcons.length; i++) {
                   weatherIcons[i].setAttribute('colors',`primary:${this.#weatherIconColors.primaryColor},secondary:${this.#weatherIconColors.secondaryColor}`);
                   weatherIcons[i].setAttribute('isActiveWeather', false);
               }
               icon.setAttribute('colors',`primary:${this.#weatherIconColors.activeColor},secondary:${this.#weatherIconColors.activeColor}`);
               icon.setAttribute('isActiveWeather', true);
               Weather.effects[currentId].hasOwnProperty('effect') && PostFX.enable();
               Weather.effects[currentId].enable();
               Weather.#selectedWeather = e.target;
           } else {
               icon.setAttribute('colors',`primary:${this.#weatherIconColors.primaryColor},secondary:${this.#weatherIconColors.secondaryColor}`);
               icon.setAttribute('isActiveWeather', false);
               PostFX.disable();
               Weather.effects[currentId].disable();
               Weather.#selectedWeather = null;
           }
       }
    }

    static render(time) {
        if (!Weather.#active) return;

        Weather.effects.snow?.update(time);
        Weather.effects.rain?.update(time);
        Weather.effects.clouds?.update(time);
        Weather.effects.thunderstorm?.update(time);
        Weather.effects.drizzle?.update(time);
    }

    static isActive() {
        return Weather.#active;
    }

    static isEnabled() {
        return Boolean(Weather.#selectedWeather);
    }

    static toggle(action) {

        if (!Weather.isActive()) return;

        const id = Weather.#selectedWeather?.id;

        switch (action) {
            case 'enable':
                Weather.#container.classList.remove('hidden');

                if (Weather.#selectedWeather && !Weather.#selectedWeather.checked) {
                    Weather.effects[id].hasOwnProperty('effect') && PostFX.enable();
                    Weather.effects[id].enable();
                    Weather.#selectedWeather.checked = true;
                }
                // } else {
                //     Weather.effects[Weather.#defaultWeather].hasOwnProperty('effect') && PostFX.enable();
                //     Weather.effects[Weather.#defaultWeather].enable();
                //     Weather.#selectedWeather = document.querySelector(`.weather-item.${Weather.#defaultWeather}>input`);
                //     Weather.#selectedWeather.checked = true;
                // }

                break;
            case 'disable':

                if (id) {
                    Weather.effects[id].hasOwnProperty('effect') && PostFX.disable();
                    Weather.effects[id].disable();
                    Weather.#selectedWeather.checked = false;
                    // Weather.#selectedWeather = null;
                }

                Weather.#container.classList.add('hidden');

                break;
        }
    }
}
